import { Env } from './environment.model';
export const environment: Env = {
  production: true,
  disableLogs: true,
  auth: {
    isLocalLoginEnabled: false,
    // TODO redirect URL
    redirectUrl:
      'https://www.radioking.com/login?redirect=https:%2F%2Fmobile.radioking.com',
  },
  urls: {
    MAIN_API: 'https://api.radioking.io',
    MOBILE_API: 'https://mobile.api.radioking.com',
    RADIOKING_DOMAIN: 'radioking.com',
    SIMULATOR: 'https://mobile-simulator.radioking.com',
    LISTENING: 'https://play.radioking.io',
  },
  whmcs: {
    url: 'https://www.radioking.com/on',
    basic: {
      customFieldId: '183',
      planId: '61',
      publicationAddonId: '15',
    },
    smart: {
      customFieldId: '185',
      planId: '63',
      publicationAddonId: '17',
    },
    premium: {
      customFieldId: '187',
      planId: '65',
      publicationAddonId: '17',
    },
    updateAddonId: {
      android: '11',
      ios: '13',
    },
  },
  googleMapsKey: 'AIzaSyBR1nDNYA2CUMvUJ4ACd-8hxmoEgJGYMF0',
  gtm: 'GTM-MJPC7G6',
  amplitudeKey: '3c70d2708b3dfd47859127f15a2f734c',
  cookies: {
    config: {
      domain: '.radioking.com',
      expires: 365,
      secure: true,
      path: '/',
    },
    refreshTokenKey: 'refresh_token',
    tokenKey: 'token',
  },
};
